/**
 * Created by mark on 11/12/2017.
 */



import React from 'react';
import { Row, Col, Card } from 'react-bootstrap'
export default class Authentication extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {};
    }


    componentWillMount() {
    }

    render() {

        return <div>
            <Row>
                <Col>
                    <br />
                    <br />
                    <Card body>
                        <br />
                        <center style={{ top: '-50px', marginLeft: '-75px', left: '50%', position: 'absolute' }}><img height="150px" src="./img/logos/languagenut/no-text-logo.png" /></center>
                        <br />
                        <br />
                        <center><h1 class="display-4" style={{ marginBottom: '10px' }}>Thank You!<br /><small><small></small></small></h1></center>
                        <br />
                        <p>Hartelijk dank voor het aanmelden bij Languagenut. Voor het opzetten van een account kun je contact opnemen via <a href="mailto:archie@languagenut.com">archie@languagenut.com</a> of <a href="https://www.languagenut.com/nl-nl/trainingssessie/?no_redirect=true">klik hier</a></p>
                        <b>Belangrijke functies:</b>
                        <br />

                        <ul class="fa-ul">
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Uitgebreide grammatica-, zinsbouw- en werkwoordoefeningen</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Creëer je eigen inhoud</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Uitgebreide rapportage, tracking en feedback voor je leerlingen</li>
                        </ul>
                        <hr />
                        <p>
                            <center>
                                <span style={{ fontStyle: 'italic' }}>"Languagenut is the most complete digital language resource that combines the features of Linguascope, Vocab Express and Pearson Active Learn plus a whole lot more under one platform. Languagenut offers better content, more flexibility and engages our students.

The ability to assign work to students and the Exam Revision area are great features they save us hours of time every week. The platform allows me to give written and verbal feedback to my students and is the only resource with spontaneous speech practice as homework which has been a revelation"</span>
                                <br />
                                <br />
                                <b>The British School Al Khubairat</b>
                            </center>
                        </p>
                        <center>
                            <small>Neem voor vragen contact op via <a href="mailto:archie@languagenut.com">archie@languagenut.com</a></small>
                            <br /><img height="80px" src="https://s3-eu-west-1.amazonaws.com/marketing.languagenut.com/Sales%20site/Languagenut%20Sales%20Sites%20Image%20Assets/LN%20Logo.png" />

                        </center>

                    </Card>
                </Col>
            </Row>
        </div>

    }

}